import { render, staticRenderFns } from "./FunnelCard.vue?vue&type=template&id=53b58c64"
import script from "./FunnelCard.vue?vue&type=script&lang=js"
export * from "./FunnelCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports